import moment from "moment";
import statics from "../statics";

export const parseBirthday = (birthDate) =>
  birthDate ? moment().diff(birthDate, "years") : "";

export const parseCustomerName = (customer) => { 
  if (!customer || !customer.member_type) {
    return "-";
  }
  let customerName = "";
  if (customer.member_type.id === statics.memberTypes.company) {
    customerName = customer.company_name || "-";
  } else if (customer.member_type.id === statics.memberTypes.private) {
    customerName = `${customer.first_name || ""} ${customer.last_name || ""}`;
  }
  return customerName;
};

export const parseCustomerMemberName = (customer) => {
  if (!customer) {
    return "-";
  }

  if (customer.company_name && customer.company_name.trim() !== "") {
    return customer.company_name;
  }
  
  const firstName = customer.first_name || "";
  const lastName = customer.last_name || "";
  const fullName = `${firstName} ${lastName}`.trim();

  return fullName !== "" ? fullName : "-";
};

export const parseMemberGender = (genderId) => {
  switch (genderId) {
    case 1:
      return "male";
    case 2:
      return "female";
    default:
      return "company";
  }
};

export const parseInitials = (firstName, lastName) =>
  `${firstName ? firstName.charAt(0) : ""}${
    lastName ? lastName.charAt(0) : ""
  }`.toUpperCase();
